import { render, staticRenderFns } from "./ParametricContentThreads.vue?vue&type=template&id=2d44ce12&scoped=true&"
import script from "./ParametricContentThreads.vue?vue&type=script&lang=js&"
export * from "./ParametricContentThreads.vue?vue&type=script&lang=js&"
import style0 from "./ParametricContentThreads.vue?vue&type=style&index=0&id=2d44ce12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44ce12",
  null
  
)

export default component.exports